var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1000,
    zoomAndPan: "magnify",
    viewBox: "0 0 750 749.999995",
    height: 1000,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#eaeaea",
    d: "M 750 31.25 C 750 13.976562 736.023438 0 718.75 0 L 31.25 0 C 13.976562 0 0 13.976562 0 31.25 L 0 718.75 C 0 736.023438 13.976562 750 31.25 750 L 718.75 750 C 736.023438 750 750 736.023438 750 718.75 L 750 31.25 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#364f6b",
    d: "M 218.75 125 C 166.992188 125 125 166.992188 125 218.75 C 125 270.507812 166.992188 312.5 218.75 312.5 C 270.507812 312.5 312.5 270.507812 312.5 218.75 C 312.5 166.992188 270.507812 125 218.75 125 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#039ad5",
    d: "M 281.25 487.0625 L 446.65625 321.65625 C 458.863281 309.449219 478.636719 309.449219 490.84375 321.65625 L 740.84375 571.65625 C 746.703125 577.515625 750 585.449219 750 593.75 L 750 718.75 C 750 736.023438 736.023438 750 718.75 750 L 31.25 750 C 13.976562 750 0 736.023438 0 718.75 L 0 593.75 C 0 585.449219 3.296875 577.515625 9.15625 571.65625 L 165.40625 415.40625 C 177.613281 403.199219 197.386719 403.199219 209.59375 415.40625 L 281.25 487.0625 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImage);
export default __webpack_public_path__ + "static/media/upload_image.7906a2239d8efa64b41c5e3b001b0350.svg";
export { ForwardRef as ReactComponent };